import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { GlobalState } from "../../store";
import { InventoryType } from "../types";

interface InventoryState {
  [k: string]: {
    data: InventoryType[];
    selected: InventoryType[];
  };
}

const initialState: InventoryState = {};

export const inventoriesState = createSlice({
  name: "inventories",
  initialState,
  reducers: {
    set: (
      state,
      action: PayloadAction<{ eventCode: string; inventories: InventoryType[] }>
    ) => {
      const { eventCode, inventories } = action.payload;
      if (!state[eventCode]) {
        state[eventCode] = { data: [], selected: [] };
      }
      state[eventCode].data = inventories;
    },

    updateSelection(
      state,
      action: PayloadAction<{ eventCode: string; inventory: InventoryType }>
    ) {
      const { eventCode, inventory } = action.payload;
      const selected = state[eventCode]?.selected || [];
      let isSelected = selected.some((s) => s.id === inventory.id);
      if (isSelected) {
        state[eventCode].selected = selected.filter(
          (val) => val.id !== inventory.id
        );
      } else {
        state[eventCode].selected = [...selected, inventory];
      }
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.inventories;

export const selectInventory = (eventCode: string | undefined) => {
  return createSelector(selector, (state) => {
    if (eventCode && state[eventCode]?.data) return state[eventCode]?.data;
    else return [];
  });
};

export const selectInventoriesSelected = (eventCode: string | undefined) => {
  return createSelector(selector, (state) => {
    if (eventCode && state[eventCode]?.selected)
      return state[eventCode]?.selected;
    else return [];
  });
};

export default inventoriesState.reducer;
